<template>
  <div>
    <div class="title mb-3">MAPPA TAVOLI</div>
    <div v-for="[key, sector] in Object.entries(contestCurrentStateMap)" :key="key" class="mb-4">
      <b-row class="align-middle selector">
        <b-col class="pt-2 text-center">{{ sector.Sigla }} - {{ sector.Descrizione }}</b-col>
        <b-col class="pt-2 text-right">Round</b-col>
        <b-col><combo-or-label v-model="selectedRoundByKey[key]" :options="Object.keys(sector.Rounds)"></combo-or-label></b-col>
      </b-row>

      <b-table :fields="fieldsToBeShown" :items="getTablesFrom(sector, selectedRoundByKey[key])" sort-by="round" class="figbHeader mt-3">
        <template #cell(NsEventId)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(EwEventId)="data">
          <span v-html="data.value"></span>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ComboOrLabel from "../components/lib/ComboOrLabel";

export default {
  name: 'TablesMap',
  components: {ComboOrLabel},
  data() {
    return {
      selectedRoundByKey: {}
    }
  },
  methods: {
    getTablesFrom(sector, round) {
      return Object.entries(sector.Rounds[round]?.Tables ?? {})
          .map(el => {
            const [tableNumber, table] = el;
            return {
              TableNumber: tableNumber,
              ...table
            }
      })
    },
  },
  computed: {
    ...mapGetters({
      contestCurrentStateMap: 'tournament/contestCurrentStateMap',
      pairs: 'players/pairsList'
    }),
    fieldsToBeShown() {
      const that = this;
      return [
        {
          key: 'TableNumber',
          label: "Tv."
        },
        {
          key: 'Boards',
          label: "Bds",
          formatter: value => {

            if (value.length === 0) {
              return "";
            }

            if (value.length === 1) {
              return value[0];
            }

            const ordered = [...value].map(n => Number.parseInt(n)).sort((n1, n2) => n1 - n2);

            for (let i = 1; i < ordered.length; i++) {
              if (ordered[i] !== ordered[i - 1] + 1) {
                //Not ordered board numbers, return'em all
                return ordered.join(', ');
              }
            }

            //Ordered board numbers, return first-last
            return ordered[0] + "-" + ordered[ordered.length - 1];
          }
        },
        {
          key: 'NsEventId',
          label: "NS",
          formatter: val => that.pairs[val].Name.replace(" - ", "<br>")
        },
        {
          key: 'EwEventId',
          label: "EW",
          formatter: val => that.pairs[val].Name.replace(" - ", "<br>")
        }
      ];
    }
  },
  mounted() {
    const temp = {}
    Object.entries(this.contestCurrentStateMap).forEach(([key, sector]) => {
      temp[key] = Math.min(sector.CurrentRound, Math.max(...Object.keys(sector.Rounds)))
    });
    this.selectedRoundByKey = temp;
  }
};
</script>

<style scoped>
>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}


.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}
</style>
